function* product(l, repeat) {
    const num = l.length;
    let count = 0;
    let idxs = [];
    // Init idxs which keep track of where we are
    for (let i = 0; i < repeat; i++ ) {
        idxs.push(0);
    }
    while ( count < Math.pow(num, repeat) ) {
        let prod = [];
        for (let i = 0; i < repeat; i++ ) {
            const idx = idxs[i];
            prod.push(l[idx]);
        }
        yield prod;
        // Update the idxs
        let carry = 1;
        for (let i = 0; i < repeat; i++ ) {
            let idx = idxs[i];
            let nextIdx = (idx + carry) % num;
            idxs[i] = nextIdx;
            if ( idx === (num - 1) && nextIdx !== idx) {
                carry = 1;
            }
            else {
                carry = 0;
            }
        }
        count++;
    }
}

function* combinations(l, k) {
    const num = l.length;
    if (k > num) {
        yield null;
    }
    let idxs = [];
    // Init idxs which keep track of where we are
    for (let i = 0; i < k; i++ ) {
        idxs.push(i);
    }
    let out = [];
    for (let idx of idxs) {
        out.push(l[idx]);
    }
    yield out;
    while ( true ) {
        let end = true;
        let i = k;
        while (i > 0) {
            i--;
            if (idxs[i] !== (i + num - k)) {
                end = false;
                break;
            }
        }
        if ( end === true ) {
            return;
        }
        idxs[i] += 1;
        for (let j = i + 1; j < k; j++ ) {
            idxs[j] = idxs[j-1] + 1;
        }
        let out = [];
        for (let idx of idxs) {
            out.push(l[idx]);
        }
        yield out;
    }
}


function subsets(n) {
    let subsets = [];
    for (let each of product([-1, 1], n)) {
        subsets.push(each);
    }
    return subsets
}

function subsetIdxs(n) {
    let subsets = [];
    for (let each of product([-1, 1], n)) {
      let idxs = [];
      for (let i=0; i < each.length; i++) {
        if (each[i] === 1) {
          idxs.push(i);
        }
      }
      subsets.push(idxs);
    }
    return subsets
}


export default {product, combinations, subsets, subsetIdxs};
